<!-- 组件头部 -->
<template>
    <div class="header">
        <div class="header-box">
            <div class="head-left">
                <!-- <span>{{userInfo.County}}</span> -->
                <span>高标准农田综合监测与智能分析可视化系统</span>
                <!-- <span>（{{ userInfo.roles[0] }}）</span> -->
            </div>
            <div class="head-right">
                <router-link :to="{ name: 'log' }">
                    <img src="../assets/z.png">
                </router-link>
                <span>{{ userInfo.name }}</span>
                <router-link :to="{ name: 'account' }">
                    <!-- <img :src="userInfo.HeadImage" style="width:36px;height:36px;border-radius:50%" @error="defImg"><i></i> -->
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * 头部显示
 */
import { mapState } from 'vuex'
export default {
    name: 'sideheader',
    props: {},
    data() {
        return {
            defaultImg: require('../assets/tx.png'),
            userInfo: JSON.parse(localStorage.getItem("userInfo"))
        }
    },
    // computed: {
    //     ...mapState(['userInfo'])
    // },
    methods: {
        defImg() {
            let img = event.srcElement
            img.src = this.defaultImg
            img.onerror = null // 防止闪图
        }
    }
}
</script>
<style lang='less' scoped>
.header {
    position: fixed;
    width: 100%;
    left: 0;
    top: 0;
    padding-left: 175px;
    z-index: 100;
    height: 90px;
    background-color: rgb(252, 252, 252);
}

.header-box {
    overflow: hidden;
    height: 90px;
    padding: 0 20px;
    box-shadow: 2px 2px 10px #e6e6ef;
}

.head-left {
    float: left;
    line-height: 90px;

    span {
        font-weight: bold;
        color: #1a1c2a;
        font-size: 28px;
        letter-spacing: 2px;
    }
}

.head-right {
    float: right;
    line-height: 90px;
    position: relative;
}

.head-right a {
    float: left;
    margin-left: 40px;
}

.head-right a i {
    position: absolute;
    right: 0;
    top: 20px;
    height: 10px;
    line-height: 10px;
}
</style>
